// translate router.meta.title, be used in breadcrumb sidebar tagsview
import VueI18n from 'vue-i18n'
import {console} from "vuedraggable/src/util/helper";

export function generateTitle(title) {
    const hasKey = this.$te('route.' + title)

    if (hasKey) {
        // $t :this method from vue-i18n, inject in @/lang/index.js
        const translatedTitle = this.$tc('route.' + title)
        console.log(title);
        console.log(translatedTitle);
        return translatedTitle
    }
    return title
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js